import React from 'react';
import cn from 'classnames';
import styles from './SuccessIcon.less';

const SuccessIcon: React.SFC = (): JSX.Element => (
  <svg className={styles.icon} viewBox="0 0 73 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      className={styles.bg}
      d="M2 21C2 20.4477 2.44772 20 3 20H72C72.5523 20 73 20.4477 73 21V66C73 68.7614 70.7614 71 68 71H7C4.23858 71 2 68.7614 2 66V21Z"
    />
    <line className={styles.line} y1="18.5" x2="72" y2="18.5" stroke="#5B7179" />
    <rect className={styles.hook} x="18.5" y="0.5" width="3" height="11" rx="1.5" />
    <rect
      className={cn(styles.hook, styles.right)}
      x="50.5"
      y="0.5"
      width="3"
      height="11"
      rx="1.5"
    />
    <path
      className={styles.frameLeft}
      d="M18.5 6.5H4C2.067 6.5 0.5 8.067 0.5 10V66C0.5 67.933 2.067 69.5 4 69.5H14.5M21.5 6.5H50.5"
    />
    <path
      className={styles.frameRight}
      d="M13.5 69.5H68C69.933 69.5 71.5 67.933 71.5 66L71.5 10C71.5 8.06701 69.933 6.5 68 6.5H53.5"
    />
    <polyline className={styles.checkmark} points="24,43 32,52 50,33" />
  </svg>
);

export default SuccessIcon;
